import { createFileRoute, redirect } from "@tanstack/react-router";
import { getAccessToken } from "@/shared/infrastructure/auth/token-storage";
import { DoctorLoginPage } from "@/modules/auth/presentation/pages/DoctorLoginPage";

export const Route = createFileRoute("/doctor-login")({
  beforeLoad: () => {
    if (getAccessToken()) {
      throw redirect({ to: "/doctor" });
    }
  },
  component: DoctorLoginPage,
});
